import { IonContent, IonPage, useIonRouter } from '@ionic/react'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { storageBackend, storageFrontend } from '../apiConfig'
import DummyHeader from '../components/DummyHeader'
import useBarcodeScanner from '../hooks/useBarcodeScanner'
import sendToIframe from '../sendToIframe'
import { selectSession } from '../store'

const iframeTitle = 'storage'

export default function Storage() {
  const { authToken, locale } = useSelector(selectSession)
  const [startScan, , barcode] = useBarcodeScanner()
  const { routeInfo } = useIonRouter()

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      try {
        const { name, url } = JSON.parse(event.data)

        if (name === 'loaded' && authToken) {
          sendToIframe(
            {
              name: 'customer',
              authToken,
              backendUrl: storageBackend,
              locale,
            },
            iframeTitle
          )
        }
        if (name === 'openBarcodeScanner') {
          startScan()
        }
        if (name === 'openUrl') {
          window.open(url, '_blank')
        }
      } catch {
        // ignore
      }
    }

    window.addEventListener('message', handler)

    return () => window.removeEventListener('message', handler)
  }, [authToken])

  useEffect(() => {
    if (barcode) {
      sendToIframe(
        {
          name: 'barcodeScanned',
          barcode,
        },
        iframeTitle
      )
    }
  }, [barcode])

  const iframeSrc = useMemo(() => (routeInfo.pathname.includes('/storage') ? `${storageFrontend}` : ''), [routeInfo])

  return (
    <IonPage>
      <DummyHeader />
      <IonContent>
        <iframe title={iframeTitle} src={iframeSrc} width="100%" height="100%" allowFullScreen />
        <div id="reader" />
      </IonContent>
    </IonPage>
  )
}
